export function extractVideoId(youtubeURL) {
  if (typeof youtubeURL !== 'string') return null;

  // 1. Standard, share, and embed patterns
  const patterns = [
    /(?:youtube\.com\/.*[?&]v=|youtube\.com\/v\/|youtu\.be\/|youtube\.com\/embed\/|youtube-nocookie\.com\/embed\/)([A-Za-z0-9_-]{11})/,
    /^([A-Za-z0-9_-]{11})$/ // allow just the ID itself
  ];

  // 2. Try all patterns
  for (const pattern of patterns) {
    const match = youtubeURL.match(pattern);
    if (match) return match[1];
  }

  // 3. Fallback: Try URL parsing for v= in query
  try {
    const url = new URL(youtubeURL);
    if (url.hostname.endsWith('youtube.com') || url.hostname.endsWith('youtube-nocookie.com')) {
      const v = url.searchParams.get('v');
      if (v && v.length === 11) return v;
    }
  } catch (e) {}

  return null;
}